import React from "react";
import { Col, Row } from "react-bootstrap";

function Headline({ text, underlined = false, isPrimary = false }) {
  const primaryClass = "mainheadline";
  return (
    <div>
      <Row>
        <Col md={8}>
          <h1 className={isPrimary === true ? primaryClass : ""}>{text}</h1>
          {underlined ? <hr /> : null}
        </Col>
      </Row>
      <br />
    </div>
  );
}

export default Headline;
